<ngb-accordion activeIds="waste-info">
    <ngb-panel id="waste-info">
        <ng-template ngbPanelHeader let-panel>
            <h5 translate>Waste Information</h5>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row mb-3">
                <div class="col">
                    <app-control label='Planned Depot - Malta' type="codelist" codelist="WasteDelivery"
                        [isDisabled]="!canEdit || !editMode" [(ngModel)]="model.wasteDeliveryId" [entity]="model" property="wasteDeliveryId"></app-control>
                </div>
                <div class="col">
                    <app-control label='Last port of waste delivered' type="codelist" codelist="Location"
                        [isDisabled]="!canEdit || !editMode" [(ngModel)]="model.wasteLastDeliveryPortId" [entity]="model" property="wasteLastDeliveryPortId"></app-control>
                </div>
                <div class="col">
                    <app-control label='Date of last delivery' type="datetime"
                        [isDisabled]="!canEdit || !editMode" [(ngModel)]="model.wasteLastDeliveryDate" [entity]="model" property="wasteLastDeliveryDate"></app-control>
                </div>
                <div class="col">
                    <app-control label='Sufficient on board capacity' type="yesno" [isDisabled]="!canEdit || !editMode"
                        [(ngModel)]="model.sufficientWasteOnBoardCapacity" [entity]="model" property="sufficientWasteOnBoardCapacity"></app-control>
                </div>
                <div class="col">
                    <app-control label='Next Port Waste will be delivered' type="codelist" codelist="Location"
                        [isDisabled]="!canEdit || !editMode" [(ngModel)]="model.wasteNextDeliveryPortId" [entity]="model" property="wasteNextDeliveryPortId"></app-control>
                </div>
            </div>
            <ngb-accordion activeIds="waste-list">
                <ngb-panel id="waste-list">
                    <ng-template ngbPanelHeader let-panel>
                        <div class="row">
                            <div class="col-md-auto">
                                <h5 translate>Waste Disposal Information</h5>
                            </div>
                            <div class="col" style="margin-left: -9px; margin-top: 2px;">
                                <strong style="font-size: 13px;">- Any waste quantity which will not be reported, will
                                    be set as “0”</strong>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <h3 translate>Waste List</h3>
                        <app-vessel-notification-waste-grid [model]="model" [canEdit]="canEdit" [editMode]="editMode"></app-vessel-notification-waste-grid>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
<div class="mb-3"></div>
<app-vessel-notification-attachment [attachments]="model.attachments" [canEdit]="canEdit" [editMode]="editMode"
    title='Supporting Documents' [user]="user"></app-vessel-notification-attachment>
